export default __webpack_public_path__ + "static/media/no-incidents-img.86f4851a.svg";